import React, {useRef, useState } from "react";
import { Button } from "react-bootstrap";
import { Card, CardBody, CardHeader, CardHeaderToolbar } from "../../../../_metronic/_partials/controls";
import {
    errorMessage,
    formatDate,
} from "../../../util/Helpers";
import SVG from "react-inlinesvg";
import DynamicSimpleTable from "../../../util/DynamicSimpleReactTable";
import cogoToast from "cogo-toast";
import { Permissions, PermissionType } from "../../../util/Permissions";

import { FilterGroup } from "../../Common/components/FilterGroup";
import { Permission } from "../../Common/layout/Permission"
import { EditIcon, ViewIcon } from "../../../util/Icons";
import CreateCampaignModal from "./modals/CreateCampaignModal";
import EditCampaignModal from "./modals/EditCampaignModal";
import DeleteCampaignModal from "./modals/DeleteCampaignModal";
import { toAbsoluteUrl } from "../../../../_metronic/_helpers";
import ViewCampaignModal from "./modals/ViewCampaignModal";


export const Campaigns = (
    {
        match: {
            params: { userGroup },
        },
    }
) => {
    // Campaing Creation Redux state
    const tableRef = useRef();

    /*  Campaing Creation Modal State Management */
    const [campaignModal, setCampaignModal] = useState({
        showCreateCampaignModal: false,
        showEditCampaignModal: false,
        showDeleteCampaignModal: false,
        showViewCampaignModal: false,
        details: null
    });

    /* Modal show/hide Toggle */
    const toggleModal = modal => _ => {
        setCampaignModal({ ...campaignModal, [modal]: !campaignModal[modal] })
    }

    /* Create Campaign */
    const createCampaign = details => {
        setCampaignModal({
            ...campaignModal,
            showCreateCampaignModal: true,
            details
        })
    }
    /* Delete Campaign Modal */
    const deleteCampaign = (details) => {
        setCampaignModal({
            ...campaignModal,
            showDeleteCampaignModal: true,
            details,
        });
    };

    /* Edit  Campaing  Modal*/
    const editCampaign = details => {
        setCampaignModal({
            ...campaignModal,
            showEditCampaignModal: true,
            details
        })
    }
    /* View  Campaing  Details */
    const viewCampaign = details => {
        setCampaignModal({
            ...campaignModal,
            showViewCampaignModal: true,
            details
        })
    }



    /* Action Buttons */
    const campaignAction = (row) => {
        return (
            <span style={{ whiteSpace: "nowrap" }}>

                <Permission permission={Permissions.CAMPAIGNS} permissionType={PermissionType.UPDATE}>
                    <Button
                        title="View Campaign"
                        className="btn btn-icon btn-light btn-hover-primary btn-sm bg-white"
                        onClick={_ => viewCampaign(row)}
                    >
                        <span className="svg-icon svg-icon-md svg-icon-primary">
                            <ViewIcon />
                        </span>
                    </Button>
                    <Button
                        title="Edit Campaign"
                        className={`btn btn-icon btn-light btn-hover-primary btn-sm mx-3`}
                        onClick={_ => editCampaign(row)}
                    >
                        <span className={`svg-icon svg-icon-md svg-icon-primary`}>
                            <EditIcon />
                        </span>
                    </Button>
                    <Button
                        title="Delete Campaign"
                        className={`btn btn-icon btn-light btn-hover-primary btn-sm mx-3`}
                        onClick={_ => deleteCampaign(row)}
                    >
                        <span className={`svg-icon svg-icon-md svg-icon-danger`}>
                            <SVG
                                title="Disable User"
                                src={toAbsoluteUrl("/media/svg/icons/Code/Error-circle.svg")}
                            />
                        </span>
                    </Button>

                </Permission>
            </span>
        );
    };

    return (
        <div className="py-4 px-6">
            <FilterGroup
                key={userGroup}
            >
                <FilterGroup.DateRange className={"mb-4"} />
                <div className="d-flex mb-4">
                    <div className={"mr-4"}>
                        <FilterGroup.Filter name={"type"} label={"Type"}>
                            <FilterGroup.Option value="">All</FilterGroup.Option>
                            <FilterGroup.Option value="ORDER">ORDER</FilterGroup.Option>
                            <FilterGroup.Option value="REFERRAL">REFERRAL</FilterGroup.Option>
                        </FilterGroup.Filter>
                    </div>
                </div>
                <FilterGroup.Content>
                    {
                        ({ filters }) => {
                            return <Card>
                                <CardHeader title={`Campaigns`} >
                                    <Permission permission={Permissions.CAMPAIGNS} permissionType={PermissionType.CREATE}>
                                        <CardHeaderToolbar>
                                            <button
                                                type="button"
                                                className="btn btn-primary"
                                                onClick={() => createCampaign()}
                                            >
                                                Create Campaign
                                            </button>
                                        </CardHeaderToolbar>

                                    </Permission>

                                </CardHeader>
                                <CardBody>

                                    <DynamicSimpleTable
                                        key={userGroup}
                                        queryParams={
                                            `userGroup=${userGroup}`
                                            + `&type=${filters?.type || ""}`
                                            + `&startDate=${filters?.startDate || ""}`
                                            + `&endDate=${filters?.endDate || ""}`
                                        }
                                        searchBox={true}
                                        source={{ url: `/campaigns` }}
                                        columns={[
                                            { title: "NAME", key: "name" },
                                            { title: "Duration", key: "durationType" },
                                            { title: "TARGET", key: "target" },
                                            { title: "TYPE", key: "type" },
                                            { title: "TIMELINE", key: "timeline" },
                                            { title: "REWARD AMOUNT", key: "rewardAmount" },
                                            { title: "START DATE", format: (row) => formatDate(row.created) },
                                            { title: "END DATE", format: (row) => formatDate(row.endDate) },
                                            { title: "", format: campaignAction }
                                        ]}
                                        ref={tableRef}
                                        onError={(err) =>
                                            cogoToast.error(errorMessage(err))
                                        }
                                        refreshIcon={true}
                                    />
                                </CardBody>
                            </Card>
                        }
                    }
                </FilterGroup.Content>
            </FilterGroup>

            <CreateCampaignModal
                {...campaignModal}
                onHide={toggleModal("showCreateCampaignModal")}
            />
            <EditCampaignModal
                {...campaignModal}
                onHide={toggleModal("showEditCampaignModal")}
                tableRef={tableRef}
            />
            <DeleteCampaignModal
                {...campaignModal}
                onHide={toggleModal("showDeleteCampaignModal")}
                tableRef={tableRef}
            />
            <ViewCampaignModal
                {...campaignModal}
                onHide={toggleModal("showViewCampaignModal")}
                tableRef={tableRef}
            />
        </div>
    );
};
